import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useWindowSize } from 'react-use';
import { AppBar, Box, Button, Typography } from '@mui/material';
import { Logout, Person, KeyboardArrowDown, KeyboardArrowUp, Menu, Close } from '@mui/icons-material';
import { useAuth0 } from '@auth0/auth0-react';

import { useState } from 'react';
import { ROUTES } from '../consts';
import headerLogo from '../assets/images/road2college_header_logo.png';
import { palette } from '../configs';
import { selectUser } from '../store/selectors';

interface GeneralHeaderLayoutProps {}

export const GeneralHeaderLayout: React.FC<GeneralHeaderLayoutProps> = () => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <AppBar
      position="fixed"
      style={{
        background: 'white',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: windowSize.width <= 630 ? '2vw 4vw 2vw 4vw' : '1vw 4vw 1vw 3vw',
      }}
    >
      <Box style={{ display: 'flex', alignItems: 'center', minHeight: 'unset' }}>
        <Box
          display="flex"
          alignItems="center"
          onClick={() => navigate('/')}
          sx={{
            cursor: 'pointer',
          }}
        >
          <img
            src={headerLogo}
            alt="Road2College"
            style={{
              height: windowSize.width <= 630 ? 25 : 35,
              paddingRight: windowSize.width <= 630 ? '7px' : '13px',
            }}
          />
        </Box>
        <Typography
          onClick={() => navigate('/')}
          sx={{
            cursor: 'pointer',
          }}
          style={{
            fontFamily: 'Source Serif Pro',
            color: palette.primary.dark,
            fontSize: windowSize.width <= 630 ? 15 : 25,
            lineHeight: windowSize.width <= 630 ? '25px' : '35px',
            paddingLeft: windowSize.width <= 630 ? '7px' : '13px',
            borderLeft: '2px solid #030054',
          }}
        >
          Compare Offers
        </Typography>
      </Box>
      {windowSize.width <= 630 ? (
        !showMenu ? (
          <Menu style={{ color: palette.primary.dark, cursor: 'pointer' }} onClick={() => setShowMenu(true)} />
        ) : (
          <Close style={{ color: palette.primary.dark, cursor: 'pointer' }} onClick={() => setShowMenu(false)} />
        )
      ) : (
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          {!isAuthenticated && (
            <Typography
              style={{
                color: palette.primary.contrastText,
                fontFamily: 'Montserrat',
                fontWeight: 500,
                cursor: 'pointer',
                fontSize: windowSize.width <= 630 ? 14 : 16,
              }}
              onClick={loginWithRedirect}
            >
              LogIn
            </Typography>
          )}
          {isAuthenticated ? (
            <Button
              style={{
                color: palette.primary.contrastText,
                backgroundColor: '#F4F5F9',
                padding: windowSize.width <= 630 ? '5px' : '10px',
                borderRadius: '40px',
                fontWeight: 600,
                marginLeft: '2vw',
                border: `1px solid rgba(106, 110, 131, 0.2)`,
                fontSize: windowSize.width <= 630 ? 14 : 16,
              }}
              onClick={() => setShowMenu((prev) => !prev)}
            >
              {(user as any)?.name || user?.email.split('@')[0]}
              {showMenu ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </Button>
          ) : (
            <Button
              style={{
                color: 'white',
                backgroundColor: palette.secondary.main,
                padding: windowSize.width <= 630 ? '5px' : '10px',
                borderRadius: '40px',
                fontFamily: 'Montserrat',
                fontWeight: 600,
                marginLeft: '2vw',
                fontSize: windowSize.width <= 630 ? 14 : 16,
              }}
              onClick={() => loginWithRedirect({ screen_hint: 'signup' })}
            >
              Get Started
            </Button>
          )}
        </Box>
      )}
      {showMenu && isAuthenticated && (
        <Box
          style={{
            position: 'absolute',
            top: 80,
            background: 'white',
            borderRadius: '10px',
            overflow: 'hidden',
            width: '17%',
            minWidth: '150px',
            right: '4vw',
            boxShadow: '0px 6px 16px -8px rgba(47, 45, 70, 0.06), 0px 8px 32px rgba(47, 45, 70, 0.14)',
          }}
        >
          <Box
            style={{ cursor: 'pointer', padding: '10%', minWidth: 'max-content', display: 'flex' }}
            sx={{
              '&:hover': {
                background: 'rgba(126, 16, 110, 0.1)',
              },
            }}
            onClick={() => {
              setShowMenu(false);
              navigate(ROUTES.PROFILE);
            }}
          >
            <Person /> <Box style={{ paddingLeft: 10 }}>Profile</Box>
          </Box>
          <Box
            style={{ cursor: 'pointer', padding: '10%', minWidth: 'max-content', display: 'flex' }}
            sx={{
              '&:hover': {
                background: 'rgba(126, 16, 110, 0.1)',
              },
            }}
            onClick={() =>
              logout({
                returnTo: window.location.origin,
              })
            }
          >
            <Logout /> <Box style={{ paddingLeft: 10 }}>Log out</Box>
          </Box>
        </Box>
      )}
      {showMenu && !isAuthenticated && windowSize.width <= 630 && (
        <Box
          style={{
            position: 'absolute',
            top: 80,
            background: 'white',
            borderRadius: '10px',
            overflow: 'hidden',
            width: '17%',
            minWidth: '150px',
            right: '4vw',
            boxShadow: '0px 6px 16px -8px rgba(47, 45, 70, 0.06), 0px 8px 32px rgba(47, 45, 70, 0.14)',
          }}
        >
          <Box
            style={{ cursor: 'pointer', padding: '10%', minWidth: 'max-content', display: 'flex' }}
            sx={{
              '&:hover': {
                background: 'rgba(126, 16, 110, 0.1)',
              },
            }}
            onClick={() => {
              setShowMenu(false);
              loginWithRedirect();
            }}
          >
            <Box style={{ paddingLeft: 10 }}>Login</Box>
          </Box>
          <Box
            style={{ cursor: 'pointer', padding: '10%', minWidth: 'max-content', display: 'flex' }}
            sx={{
              '&:hover': {
                background: 'rgba(126, 16, 110, 0.1)',
              },
            }}
            onClick={() => {
              setShowMenu(false);
              loginWithRedirect({ screen_hint: 'signup' });
            }}
          >
            <Box style={{ paddingLeft: 10 }}>Get started</Box>
          </Box>
        </Box>
      )}
    </AppBar>
  );
};
